export const STORAGE_KEY = 'wallet_auth_state';
